<template>
  <div class="store-permission">
    <el-row :gutter="20">
      <el-col :span="10">
        <el-card shadow="hover" class="store-tree-card">
          <div slot="header"><strong>门店选择</strong></div>
          <el-input v-model="filterText" placeholder="搜索门店名称或ID" size="small" clearable @input="onFilterTextChange" style="margin-bottom: 10px;">
            <i slot="prefix" class="el-icon-search"></i>
          </el-input>
          <el-tree 
            ref="storeTree" 
            :data="storeList" 
            node-key="I_门店Id" 
            :props="defaultProps" 
            show-checkbox 
            highlight-current 
            default-expand-all 
            :check-strictly="false" 
            @check="handleStoreCheck" 
            @node-click="handleNodeClick"  
            :filter-node-method="filterNode"
          >
            <div class="custom-tree-node" slot-scope="{ data }">
              <div style="margin-right: 10px;">
                <el-tag :key="data.C_门店类型" size="small" v-if="data.C_门店类型 === '门店'">{{ data.C_门店类型 }}</el-tag>
                <el-tag :key="data.C_门店类型" size="small" type="danger" v-if="data.C_门店类型 === '配送中心'">{{ data.C_门店类型 }}</el-tag>
                <el-tag :key="data.C_门店类型" size="small" type="warning" v-if="data.C_门店类型 === '分组'">{{ data.C_门店类型 }}</el-tag>
                <el-tag :key="data.C_门店类型" size="small" v-if="data.C_门店类型 === '外部客户'">{{ data.C_门店类型 }}</el-tag>
              </div>
              <div>({{ data.I_门店Id }}) {{ data.C_门店名称 }}</div>
            </div>
          </el-tree>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card shadow="hover" class="permission-card">
          <div slot="header">
            <strong>权限配置</strong>
          </div>

          <div v-if="selectedStores.length === 0" class="empty">
            请选择左侧门店/分组查看权限
          </div>

          <div 
            v-for="item in selectedStores" 
            :key="item.I_门店Id" 
            class="store-permission-block" 
            :id="`permission-block-${item.I_门店Id}`"  
          >
            <h4>{{ item.C_门店名称 }}（{{ item.C_门店类型 }}）</h4>

            <div v-for="(perm, pIndex) in item.mx" :key="pIndex"  class="permission-group">
              <el-checkbox v-model="perm.check" @change="() => onPermissionGroupChange(item, perm)" >
                {{ perm.label }}
              </el-checkbox>

              <div class="perm-sublist" v-if="perm.mx && perm.mx.length">
                <el-checkbox 
                  v-for="(sub, sIndex) in perm.mx" 
                  :key="sIndex" 
                  v-model="sub.check"  
                  @change="() => { emitSubPermissionChange(item, perm, sub); }"
                >
                  {{ sub.label }}
                </el-checkbox>
              </div>
            </div>

            <el-divider></el-divider>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "StorePermission",
  props: {
    value: { type: Array, required: true }
  },
  data() {
    return {
      storeList: JSON.parse(JSON.stringify(this.value)),
      checkedKeys: [],
      defaultProps: { label: "C_门店名称", children: "list" },
      filterText: ""
    };
  },
  computed: {
    selectedStores() {
      const result = [];
      const checkedGroups = [];
      const checkedLeafNodes = [];

      const walk = (list, level = 0, parentIds = []) => {
        list.forEach(item => {
          const isChecked = this.checkedKeys.includes(item.I_门店Id);
          if (isChecked) {
            if (this.isGroup(item)) {
              checkedGroups.push({
                ...item,
                level,
                parentIds
              });
            } else {
              if (!parentIds.some(pid => checkedGroups.some(g => g.I_门店Id === pid))) {
                checkedLeafNodes.push(item);
              }
            }
          }

          if (item.list && item.list.length) {
            const newParentIds = this.isGroup(item) ? [...parentIds, item.I_门店Id] : parentIds;
            walk(item.list, level + 1, newParentIds);
          }
        });
      };

      walk(this.storeList);

      const topLevelGroups = checkedGroups.filter(group => {
        return !group.parentIds.some(pid => checkedGroups.some(g => g.I_门店Id === pid));
      });

      result.push(...topLevelGroups, ...checkedLeafNodes);
      return result;
    }
  },
  watch: {
    filterText(val) {
      this.$refs.storeTree?.filter(val);
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initCheckedKeys();
      // 初始化时同步所有已勾选分组的权限到子节点
      this.syncAllGroupPermissionsToChildren();
    });
  },
  methods: {
    isGroup(item) {
      return item.C_门店类型 === "分组";
    },
    
    filterNode(value, data) {
      if (!value) return true;
      return data.C_门店名称?.includes(value) || String(data.I_门店Id).includes(value);
    },

    onFilterTextChange(val) {
      this.$refs.storeTree?.filter(val);
    },

    initCheckedKeys() {
      const checkedIds = [];
      const collectCheckedIds = (list) => {
        list.forEach(item => {
          if (item.check) {
            checkedIds.push(item.I_门店Id);
          }
          if (item.list && item.list.length) {
            collectCheckedIds(item.list);
          }
        });
      };
      collectCheckedIds(this.storeList);
      this.checkedKeys = checkedIds;
      this.$refs.storeTree?.setCheckedKeys(checkedIds);
    },

    handleStoreCheck(checkedNodes, info) {
      this.checkedKeys = info.checkedKeys || [];
      const syncCheckStatus = (list) => {
        list.forEach(item => {
          item.check = this.checkedKeys.includes(item.I_门店Id);
          if (item.list && item.list.length) {
            syncCheckStatus(item.list);
          }
        });
      };
      syncCheckStatus(this.storeList);
      // 勾选分组后同步权限到子节点
      this.syncAllGroupPermissionsToChildren();
      this.emitUpdate();
    },

    handleNodeClick(data) {
      if (this.checkedKeys.includes(data.I_门店Id)) {
        this.$nextTick(() => {
          const targetElement = document.getElementById(`permission-block-${data.I_门店Id}`);
          if (targetElement) {
            targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        });
      }
    },

    findNodeById(list, id) {
      for (const item of list) {
        if (item.I_门店Id === id) return item;
        if (item.list && item.list.length) {
          const found = this.findNodeById(item.list, id);
          if (found) return found;
        }
      }
      return null;
    },

    /** 同步单个分组的权限到旗下所有子节点 */
    /** 同步分组权限到子节点（仅匹配已有权限项） */
    syncGroupPermissionToChildren(group) {
      if (!group || !group.list || !group.mx) return;

      const syncPermission = (list) => {
        list.forEach(item => {
          if (item.mx && group.mx) {
            // 遍历子节点已有权限，仅匹配父分组同名权限项的勾选状态
            item.mx.forEach(childPerm => {
              const parentPerm = group.mx.find(p => p.label === childPerm.label);
              if (parentPerm) {
                childPerm.check = parentPerm.check;
                // 同步子权限项（如“全部”“查看”等）
                if (childPerm.mx && parentPerm.mx) {
                  childPerm.mx.forEach(childSub => {
                    const parentSub = parentPerm.mx.find(ps => ps.label === childSub.label);
                    if (parentSub) childSub.check = parentSub.check;
                  });
                }
              }
            });
          }
          // 递归同步子分组
          if (item.list && item.list.length) syncPermission(item.list);
        });
      };
      syncPermission(group.list);
    },

    /** 同步所有已勾选分组的权限到子节点 */
    syncAllGroupPermissionsToChildren() {
      const walk = (list) => {
        list.forEach(item => {
          if (this.isGroup(item) && this.checkedKeys.includes(item.I_门店Id)) {
            this.syncGroupPermissionToChildren(item);
          }
          if (item.list && item.list.length) {
            walk(item.list);
          }
        });
      };
      walk(this.storeList);
    },

    onPermissionGroupChange(store, perm) {
      if (perm.mx && perm.mx.length) {
        perm.mx.forEach(sub => (sub.check = perm.check));
      }
      // 仅当是分组且权限变更时，同步子节点已有权限
      if (this.isGroup(store)) {
        this.syncGroupPermissionToChildren(store);
      }
      this.emitUpdate();
    },

    

    emitUpdate() {
      this.$emit("input", this.storeList);
      this.$emit("update", this.storeList);
    }
  }
};
</script>

<style scoped>
.store-permission {
  width: 1000px;
}

.store-tree-card,
.permission-card {
  height: calc(100vh - 180px);
  overflow-y: auto;
}

.custom-tree-node {
  display: flex;
  align-items: center;
}

.store-permission-block {
  margin-bottom: 10px;
}

.permission-group {
  margin-left: 20px;
  margin-top: 5px;
}

.perm-sublist {
  margin-left: 25px;
  margin-top: 5px;
}

.empty {
  color: #999;
  text-align: center;
  padding: 40px 0;
}
</style>